import * as React from "react";
import * as uuid from "uuid";

import { DrawerViewModel, DrawerViewProps } from "../../Common";

import {
  useMyBagOutOfStockUserExperience,
  useMyBagOutOfStockUserExperience_asController,
} from "../providers";

export const DrawerFragment_OutOfOStock_ViewModel: DrawerViewProps["useDrawerViewModel"] =
  () => {
    const {
      shouldIPresentAnOutOfStockDrawer:
        shouldIPresentAnOutOfStockDrawer_mybagOutOfStockUserExperience,
    } = useMyBagOutOfStockUserExperience();

    const { handleClose: handleClose_mybagOutOfStockUserExperience } =
      useMyBagOutOfStockUserExperience_asController();

    const this_guid = React.useMemo(() => {
      return uuid.v4();
    }, []);

    const handleClose = React.useCallback(() => {
      handleClose_mybagOutOfStockUserExperience();
    }, [handleClose_mybagOutOfStockUserExperience]);

    const present = React.useMemo(() => {
      return shouldIPresentAnOutOfStockDrawer_mybagOutOfStockUserExperience;
    }, [shouldIPresentAnOutOfStockDrawer_mybagOutOfStockUserExperience]);

    const className = React.useMemo(() => {
      return `bbnt-checkout-2022 out-of-stock`;
    }, []);

    const value: DrawerViewModel = React.useMemo(
      () => ({
        guid: this_guid,
        present,
        className,
        handleClose,
      }),
      [this_guid, present, className, handleClose]
    );
    return value;
  };
